import React, { PropTypes } from 'react';
import RaisedButton  from 'material-ui/RaisedButton';
import ErrorContainer from '../../../form/ErrorContainer';

class VotingToolBar extends React.Component {
  static propTypes = {
    publish: PropTypes.func.isRequired,
    save: PropTypes.func.isRequired,
    announceResult: PropTypes.func.isRequired,
    canSave: PropTypes.bool.isRequired,
    canPublish: PropTypes.bool.isRequired,
    canAnnounce: PropTypes.bool.isRequired,
    needPublish: PropTypes.bool,
    prepareData: PropTypes.func
  };

  state = {
    processingBingo: false
  };

  async announceResult() {
    let { prepareData, announceResult } = this.props;

    try {
      let announceData = prepareData ? await prepareData() : {};

      this.setState({ processingBingo: true });

      return await announceResult(announceData);
    }

    catch(e) {
      if (e !== false) {
        throw e;
      }
    }

    finally {
      this.setState({ processingBingo: false })
    }
  }

  async save() {
    let { save } = this.props;

    this.setState({ processingBingo: true });

    try {
      await save();
    }

    finally {
      this.setState({ processingBingo: false });
    }
  }

  async publish() {
    let { publish } = this.props;

    this.setState({ processingBingo: true });

    try {
      await publish();
    }

    finally {
      this.setState({ processingBingo: false });
    }
  }

  render() {
    let { processingBingo } = this.state;
    let { canSave, canPublish, canAnnounceResult, isPublished, error, needPublish } = this.props;

    return (
      <div>
        <div>
          <ErrorContainer displayLabel={false} error={error} touched={true}></ErrorContainer>
        </div>
        <div style={{textAlign: 'center'}}>
          {canSave
            ? <RaisedButton label="Save" primary={true} disabled={processingBingo}
                           onClick={() => this.save()}/>
            :null
          }

          {canPublish
            ? <RaisedButton style={{marginLeft: 10}}
                            label="Publish" primary={true} disabled={processingBingo}
                            onClick={() => this.publish()}/>
            : null
          }
          {isPublished && needPublish
            ? <RaisedButton label="Announce result" primary={true} disabled={processingBingo || !canAnnounceResult}
                            onClick={() => this.announceResult()}/>
            : null
          }
          {isPublished && !canAnnounceResult && needPublish
              ? <span style={{fontSize: 14, marginLeft: 10}}>
                  Result can be announced on voting that ended only.
                </span>
              : null
          }
        </div>
      </div>
    );
  }
}

VotingToolBar.defaultProps = {
  canSave: false,
  canPublish: false,
  canAnnounce: false
};

export default VotingToolBar;




// WEBPACK FOOTER //
// ./src/components/Events/EventsEditForm/votings/VotingToolBar.jsx